import type { IErrorResponseSchema } from 'shared/repositories/commercial-buildings/entities/schemas/ErrorResponseSchema';
import type { ICategoryOffers } from 'shared/types/buildingOffers';

const NOT_FOUND_ERROR_CODE = 'notFound';

const isNotFoundError = (error: object): boolean => 'code' in error && error.code === NOT_FOUND_ERROR_CODE;

/** Здание не найдено — пустая выборка, как прокси монолита; остальные ошибки — исключение */
export const mapResponse400 = (response: IErrorResponseSchema): ICategoryOffers => {
  if (response.errors?.some(isNotFoundError)) {
    return { offers: [], offersCount: 0 };
  }

  throw new Error(response.message || 'Неизвестная ошибка');
};
